import { OutlinedTextFieldProps, Typography } from '@material-ui/core';
import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { CustomTextAreaAutosize, CustomTypography, InputDiv } from './Input.styled';

interface IProps extends FieldRenderProps<string> {
  label: string;
  rowsMin?: number;
  textFieldProps?: Omit<OutlinedTextFieldProps, 'variant'>;
  disabled?: boolean;
}

type PropType = IProps;

const CustomTextArea = ({ meta, input, label, rowsMin, disabled }: PropType): JSX.Element => {
  const { t } = useTranslation();
  const shouldDisplayError = (typeof meta.error === 'boolean' || (meta.error && meta.touched)) as boolean;

  return (
    <InputDiv>
      <CustomTypography color="textSecondary" variant="subtitle2">
        {t(label)}
      </CustomTypography>

      <CustomTextAreaAutosize rowsMin={rowsMin || 4} error={+shouldDisplayError || 0} {...input} disabled={disabled} />
      {shouldDisplayError && typeof meta.error !== 'boolean' && (
        <Typography variant="caption" color="error">
          {t(meta.error as string)}
        </Typography>
      )}
    </InputDiv>
  );
};

export default CustomTextArea;
